import apiClient from './api'

/**
 * Servicio para gestión de planes de suscripción
 */
const subscriptionService = {
  /**
   * Obtener información del plan de una empresa
   */
  async getPlanInfo(companyId) {
    try {
      const response = await apiClient.get(`/companies/${companyId}/plan`)
      return response.data
    } catch (error) {
      console.error('Error getting plan info:', error)
      throw error
    }
  },

  /**
   * Actualizar plan de una empresa
   */
  async updatePlan(companyId, planData) {
    try {
      const response = await apiClient.put(`/companies/${companyId}/plan`, planData)
      return response.data
    } catch (error) {
      console.error('Error updating plan:', error)
      throw error
    }
  },

  /**
   * Verificar si una funcionalidad está disponible
   */
  hasFeature(planInfo, feature) {
    return planInfo?.features?.[feature] ?? false
  },

  /**
   * Verificar si es plan enterprise
   */
  isEnterprise(planInfo) {
    return planInfo?.plan === 'enterprise'
  },

  /**
   * Verificar si es plan básico
   */
  isBasic(planInfo) {
    return planInfo?.plan === 'basic'
  },

  /**
   * Obtener porcentaje de uso de facturas
   */
  getInvoiceUsagePercent(planInfo) {
    if (!planInfo?.usage) return 0
    const { invoices_used, invoices_limit } = planInfo.usage
    if (!invoices_limit) return 0 // Ilimitado
    return Math.round((invoices_used / invoices_limit) * 100)
  },

  /**
   * Verificar si está cerca del límite (>80%)
   */
  isNearLimit(planInfo) {
    return this.getInvoiceUsagePercent(planInfo) >= 80
  },

  /**
   * Verificar si alcanzó el límite
   */
  isAtLimit(planInfo) {
    if (!planInfo?.usage) return false
    return planInfo.usage.invoices_remaining === 0
  }
}

export default subscriptionService
